import React, { useEffect, useState } from "react";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import LoadCSSforfirstTime from "../../../../../CloudStorage/LoadCSSforfirstTime";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useRouteBaseStateContext } from "../../../../../Context/RouteBaseStateContext";
import { formatNumberWithCommas } from "../../../../Common/AllDateTimeReleventFormate";
import PostNotFound from "../../../../CustomComponents/AllLoader/PostNotFound";
import { getPostPaginationList } from "../../../../../redux/project/action";
import OrderPostPagination from "../../../FindWork/SearchAll/AllPosts/CustomPagination/OrderPostPagination";
import { PAGE_SIZE } from "../../../../../redux/constants";
import { getJobActiveList } from "../../../../../redux/job/action";

export default function ActiveJobs() {
  const { urlstate, setMyorderActivejobsroute } = useRouteBaseStateContext();

  const path = "Assets/scss/myorders.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);
  const laung = localStorage.getItem("laung");
  const [lan, setlan] = useState(laung ?? "en");
  const navigate = useNavigate();
  // const dispatch = useDispatch();

  // useEffect(() => {
  //   dispatch(getJobActiveList(3));
  // }, []);

  const [listdata, setListdata] = useState("")
  const [pageNumber, setPageNumber] = useState(0);
  const dispatch = useDispatch();

  useEffect(() => {
    const data = {
      type: 3,
      index: pageNumber,
      size: PAGE_SIZE,
      status: 22
    }
    if (data) {
      dispatch(getPostPaginationList(data)).then((res) => {
        setListdata(res)
      })
    }
  }, [pageNumber]);



  return (
    <div className="order-tabs">
      <div className="tab-content">
        <div className="posted-project">
          {Array.isArray(listdata?.response) && (
            <>
              <h4>Part time Job (PTJ)</h4>
              <OrderPostPagination
                totalitemcounts={listdata?.count}
                size={PAGE_SIZE}
                pageNumber={pageNumber}
                setPageNumber={setPageNumber}
              />
              {listdata?.response?.length == 0 && <PostNotFound title={"No Post Found"} />}
              <div className="recent-post row recent-job">
                {listdata?.response.slice(0, 10).map((item, index) => (
                  <div className="col-md-6" key={index}
                    onClick={() => {
                      navigate(`/${lan}/dashboard/managework/jobs/active/${item.id}`);
                      setMyorderActivejobsroute("");
                    }}>
                    <div className="post-back recent-back">
                      <div className="recent-detail">
                        <p>
                          <img
                            src={`${CloudStorage.cloudurl}/Assets/Images/myorders/jobtype.svg`}
                            alt=""
                          />
                          Job type:
                          {item?.work_location == 1
                            ? "Virtual"
                            : item?.work_location == 2
                              ? "Physical"
                              : ""}
                        </p>
                        <h3>{item?.title}</h3>
                        <h1>
                          <h1>
                            $
                            {item?.hiring_type == 1
                              ? `${formatNumberWithCommas(item?.proposed_price)}/hr`
                              : ""}
                            {item?.hiring_type == 3
                              ? `${formatNumberWithCommas(item?.proposed_price)}/weekly`
                              : ""}
                            {item?.hiring_type == 4
                              ? `${formatNumberWithCommas(item?.proposed_price)}/month`
                              : ""}
                          </h1>
                        </h1>
                      </div>
                      <div className="recent-detail">
                        <p>Logged hour</p>
                        <h3>{item?.logged_hours || 0} hrs</h3>
                      </div>
                      <button
                        onClick={() => {
                          navigate(
                            `/${lan}/dashboard/managework/jobs/active/${item.id}`,
                          );
                          setMyorderActivejobsroute("");
                        }}
                        className="btn"
                      >
                        View details
                        <img
                          src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
